function decreaserate() {
  document.body.classList.add('draweropen');
  $('#maindecreasingsidebar').addClass('popup_open');
}

function decreaseratecloseNav() {
  document.body.classList.remove('draweropen');
  $('#maindecreasingsidebar').removeClass('popup_open');
}

function investmentbar() {
  document.body.classList.add('draweropen');
  $('#investmentside').addClass('popup_open');
}

function investmentbarcloseNav() {
  document.body.classList.remove('draweropen');
  $('#investmentside').removeClass('popup_open');
}

function getreminded() {
  document.body.classList.add('draweropen');
  $('#getreminded').addClass('popup_open');
}

function getremindedcloseNav() {
  document.body.classList.remove('draweropen');
  $('#getreminded').removeClass('popup_open');
}

function investmentplanbar() {
  document.body.classList.add('draweropen');
  $('#investmentplanside').addClass('popup_open');
}

function investmentplancloseNav() {
  document.body.classList.remove('draweropen');
  $('#investmentplanside').removeClass('popup_open');
}

// SAFE SLICK REFRESH
function refreshRecoSlider() {
  setTimeout(function () {
    var $slider = $('.custom_new-grid.cat_reco_slider');

    if (
      $slider.length &&
      typeof $slider.slick === 'function' &&
      $slider.hasClass('slick-initialized')
    ) {
      $slider.slick('setPosition');
      $(window).trigger('resize');
    }
  }, 700);
}

$(document).ready(function () {

  var mySwiper = new Swiper('.custom_slideshow-wrapper .swiper-container', {
    freeMode: true,
    slidesPerView: 4.5,
    spaceBetween: 32,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
      snapOnRelease: false
    },
    breakpoints: {
      1025: { slidesPerView: 4.5, spaceBetween: 32 },
      768: { slidesPerView: 3.5, spaceBetween: 20 },
      320: { slidesPerView: 1.2, spaceBetween: 12 }
    }
  });

  $('.product_main_sticky-wrapp .cart_btn_custom .add-to-cart').click(function () {
    $('.product-single__form .add-to-cart').trigger('click');
  });

  $('.investment_product_data button.js-qty__adjust.js-qty__adjust--plus').click(function () {
    var get_val = parseInt($(this).parents('.js-qty__wrapper').find('input').val()) + 1;
    $(this).parents('.js-qty__wrapper').find('input').val(get_val);
  });

  $('.investment_product_data button.js-qty__adjust.js-qty__adjust--minus').click(function () {
    var get_val = $(this).parents('.js-qty__wrapper').find('input').val() - 1;
    if (get_val !== 0) {
      $(this).parents('.js-qty__wrapper').find('input').val(get_val);
    }
  });

  $.fn.isOnScreen = function () {
    var win = $(window);
    var viewport = {
      top: win.scrollTop(),
      left: win.scrollLeft()
    };

    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return !(
      viewport.right < bounds.left ||
      viewport.left > bounds.right ||
      viewport.bottom < bounds.top ||
      viewport.top > bounds.bottom
    );
  };

  function toggleSticky() {
    if (
      $('.product-single__meta .product-single__form').isOnScreen() === true ||
      $('.bottom_logos_icons_wrapp').isOnScreen() === true
    ) {
      $('.product_main_sticky-wrapp').hide();
    } else {
      $('.product_main_sticky-wrapp').show();
    }
  }

  toggleSticky();

  $(window).scroll(function () {
    toggleSticky();
  });

  $(document).mouseup(function (e) {
    if (
      $(e.target).closest('#maindecreasingsidebar').length === 0 &&
      $(e.target).closest('#investmentside').length === 0 &&
      $(e.target).closest('#getreminded').length === 0 &&
      $(e.target).closest('#investmentplanside').length === 0
    ) {
      $('body').removeClass('draweropen');
      $('#investmentside').removeClass('popup_open');
      $('#maindecreasingsidebar').removeClass('popup_open');
      $('#getreminded').removeClass('popup_open');
      $('#investmentplanside').removeClass('popup_open');
    }
  });

  $(document).on('change', 'div#investmentside select.client_time', function () {
    var data_value = $(this).val();

    var final_data_value = $(
      '.loop-subscription-group-selling-plans-container .loop-selling-plan-selector option[data-title="' +
      data_value +
      '"]'
    ).val();

    $('.loop-subscription-group-selling-plans-container .loop-selling-plan-selector')
      .val(final_data_value)
      .change();
  });

  $(document).on('click', '.subscriber_ad-to-cart', function (e) {
    e.preventDefault();

    var data_id = $(this).attr('data-id');

    var selling_plan = $(
      '.loop-subscription-group-selling-plans-container .loop-selling-plan-selector option'
    ).val();

    var final_qty = $(this)
      .parents('div#investmentside')
      .find('.investment_product_data .investment_title_qty .js-qty__wrapper input.js-qty__num')
      .val();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: data_id,
        selling_plan: selling_plan,
        quantity: final_qty
      },
      dataType: 'json',

      success: function () {

        document.dispatchEvent(new CustomEvent('cart'));
        $('#HeaderCartTrigger .cart-link').trigger('click');

        document.body.classList.remove('draweropen');
        $('#investmentside').removeClass('popup_open');

        jQuery.getJSON('/cart.js', function (cart) {

          var original_price = cart.total_price,
              total_goal = $('.sidebar_progress_bar').attr('data-goal'),
              final_result = original_price / 100,
              final_val = parseInt(total_goal) - parseInt(final_result);

          $('.sidebar_progress_bar progress').val(final_result);

          if (final_result >= total_goal) {
            $('span.minus_val').hide();
            $('.free_shipping_text').show();
          } else {
            $('span.minus_val span.price_append').html(
              theme.Currency.formatMoney(final_val + '.00', theme.settings.moneyFormat)
            );
            $('span.minus_val').show();
            $('.free_shipping_text').hide();
          }
        });

        refreshRecoSlider();
      },

      error: function () {
        console.log('error');
      }
    });
  });

  // $(document).on('click', '.custom-pdp-addcart', function () {

  //   var get_var_id = $('.product-single__variants option').val();

  //   $(this).addClass('btn--loading');

  //   var data_qty = $(this)
  //     .parents('.product-single__meta')
  //     .find('.js-qty__wrapper input.js-qty__num')
  //     .val();

  //   var thisitem = $(this);

  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: {
  //       id: get_var_id,
  //       quantity: data_qty
  //     },
  //     dataType: 'json',

  //     success: function (data) {

  //       console.log(data);

  //       thisitem.removeClass('btn--loading');

  //       document.dispatchEvent(new CustomEvent('cart'));
  //       $('#HeaderCartTrigger .cart-link').trigger('click');

  //       jQuery.getJSON('/cart.js', function (cart) {

  //         var original_price = cart.total_price,
  //             total_goal = $('.sidebar_progress_bar').attr('data-goal'),
  //             final_result = original_price / 100,
  //             final_val = parseInt(total_goal) - parseInt(final_result);

  //         $('.sidebar_progress_bar progress').val(final_result);

  //         if (final_result >= total_goal) {
  //           $('span.minus_val').hide();
  //           $('.free_shipping_text').show();
  //         } else {
  //           $('span.minus_val span.price_append').html(
  //             theme.Currency.formatMoney(final_val + '.00', theme.settings.moneyFormat)
  //           );
  //           $('span.minus_val').show();
  //           $('.free_shipping_text').hide();
  //         }
  //       });

  //       refreshRecoSlider();
  //     },

  //     error: function () {
  //       console.log('error');
  //     }
  //   });
  // });

  $(document).on('click', '.custom-pdp-addcart', function () {

  var get_var_id = $('.product-single__variants option').val();

  var thisitem = $(this);

  thisitem.addClass('btn--loading');

  var data_qty = thisitem
    .parents('.product-single__meta')
    .find('.js-qty__wrapper input.js-qty__num')
    .val();

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',

    data: {
      id: get_var_id,
      quantity: data_qty
    },

    dataType: 'json',

    success: function (data) {

      console.log('PRODUCT ADDED:', data);

      thisitem.removeClass('btn--loading');

      /*
       * Keep your existing custom cart event
       */
      document.dispatchEvent(new CustomEvent('cart'));

      /*
       * IMPORTANT:
       * Do NOT manually open the cart drawer here.
       *
       * HeaderCart listens for ajaxProduct:added,
       * refreshes the cart HTML, then opens the drawer.
       */
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            addToCartBtn: thisitem[0]
          },
          bubbles: true
        })
      );

      /*
       * Update progress bar from the real Shopify cart
       */
      jQuery.getJSON('/cart.js', function (cart) {

        var original_price = cart.total_price;

        var total_goal = $('.sidebar_progress_bar').attr('data-goal');

        var final_result = original_price / 100;

        var final_val =
          parseInt(total_goal) - parseInt(final_result);

        $('.sidebar_progress_bar progress').val(final_result);

        if (final_result >= total_goal) {

          $('span.minus_val').hide();

          $('.free_shipping_text').show();

        } else {

          $('span.minus_val span.price_append').html(
            theme.Currency.formatMoney(
              final_val + '.00',
              theme.settings.moneyFormat
            )
          );

          $('span.minus_val').show();

          $('.free_shipping_text').hide();
        }

      });

      /*
       * Do NOT initialize the cart recommendation slider here.
       *
       * It is now initialized after the cart HTML
       * has been rebuilt by CartForm.buildCart().
       */

    },

    error: function (xhr) {

      thisitem.removeClass('btn--loading');

      console.log('ADD TO CART ERROR:', xhr);

    }

  });

});

  $(document).on('click', '.js-close-header-cart', function () {
    $('html').removeClass('cart-open');
    $('.site-header__cart').removeClass('is-active');
  });

  const reviews2 = setInterval(reviews, 1000);

  function reviews() {
    $('.jdgm-preview-badge span.jdgm-prev-badge__stars span.jdgm-star').each(function () {
      $(this).html(
        '<svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 21C11 10.461 21.5 10.461 21.5 10.461C11.4667 10.461 11 0.780669 11 0C10.9222 10.461 0.5 10.461 0.5 10.461C10.6889 10.461 11 20.4535 11 21Z" fill="#333333"/></svg>'
      );
      clearInterval(reviews2);
    });
  }

  $('li.rateCntbody').each(function () {
    var pro_price = $(this).find('.rateContentText').attr('discounted-text');
    var pro_discount = $(this).find('.rateContentText').attr('discount-amount');

    var afterDiscount = pro_price - (pro_price * pro_discount) / 100;

    $(this)
      .find('.rateContentText')
      .html(theme.Currency.formatMoney(afterDiscount, theme.settings.moneyFormat));
  });

});

function attachInvestmentClick() {
  $(document)
    .off('click.investmentBtn', '.investmentplan-bottom_main_btn')
    .on('click.investmentBtn', '.investmentplan-bottom_main_btn', function (e) {
      e.preventDefault();

      $('body').addClass('draweropen');
      $('#investmentplanside').removeClass('popup_open');
      $('#investmentside').addClass('popup_open');
    });
}

attachInvestmentClick();

const observer = new MutationObserver(function (mutations, obs) {

  if ($('.custom-investissement-btn').css('display') !== 'none') {
    attachInvestmentClick();
    obs.disconnect();
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

function stockpopup() {
  $('.stockpopup').addClass('active');
  $('body').addClass('stockpopup-open');
}

function closestockpopup() {
  $('.stockpopup').removeClass('active');
  $('body').removeClass('stockpopup-open');
}

const observer1 = new MutationObserver((mutations) => {

  mutations.forEach((mutation) => {

    mutation.addedNodes.forEach((node) => {

      if (node.nodeType === 1) {

        const link =
          node.matches && node.matches('a.stockist-feature-color')
            ? node
            : node.querySelector && node.querySelector('a.stockist-feature-color');

        if (link) {
          link.textContent = 'Prendre RDV';
          $('li.stockist-result .stockist-result-filters').hide();
        }
      }
    });
  });
});

observer1.observe(document.body, {
  childList: true,
  subtree: true
});